import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DevTools from 'mobx-react-devtools';

import './index.css';
import * as stores from './stores';
import registerServiceWorker from './registerServiceWorker';
import Routes from './routers';

configure({ enforceActions: 'observed' });

class App extends React.Component {
  public render() {
    return (
      <Provider {...stores}>
        <>
          <DevTools />
          <Routes />
        </>
      </Provider>
    );
  }
}


ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx